// Path: ./src/utils/constant/initialGridPaginationModel.ts
import { GridPaginationModel } from "@mui/x-data-grid";

export const initialGridPaginationModel: GridPaginationModel = {
  page: 1,
  pageSize: 100,
};
